export default __webpack_public_path__ + "static/media/s2.c3ca489d.jpg";